;(function() {
  'use strict'

  config.$inject = ["$stateProvider"];
  angular.module('app.core').config(config)

  /* @ngInject */
  function config($stateProvider) {
    $stateProvider.state('app.bundles', {
      url: '/bundles',
      templateUrl: 'bundles.html',
      controller: 'Bundles',
      controllerAs: '$ctrl',
    })
  }
})()
